const spacings = [
    { value: 'default', label: 'Default' },
    { value: 'small', label: 'Small' },
    { value: 'medium', label: 'Medium' },
    { value: 'normal', label: 'Normal' },
    { value: 'large', label: 'Large' },
    { value: 'custom', label: 'Custom' },
    { value: 'none', label: 'None' },
    { value: 'auto', label: 'Auto'}
]
export default spacings;